export default __webpack_public_path__ + "static/media/tesla.79f74c50.png";